<template>
  <div
    class="custom-container"
    :class="{ fullWidth: isFullWidth, checkoutPage: isCheckout }"
  >
    <div class="breadcrumb" v-if="breadcrumbList && breadcrumbList.length > 0">
      <ul>
        <li
          class="breadcrumb__item"
          v-for="(breadcrumb, index) in breadcrumbList"
          :key="index"
          :id="'breadcrumb__item-' + index"
        >
          <router-link :to="breadcrumb.url" exact>
            <span
              class="breadcrumb__name"
              v-if="breadcrumb && breadcrumb.name"
              >{{ breadcrumb.name }}</span
            >
            <base-icon
              name="breadcrumb"
              class="icon"
              v-if="breadcrumbList.length != index + 1"
            />
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { BaseIcon } from "@/components";
export default {
  name: "Breadcrumb",
  props: {
    isGutter: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseIcon,
  },
  data() {
    return {
      breadcrumbList: [],
      isFullWidth: false,
      isCheckout: false,
    };
  },
  mounted() {
    this.updateList();

    if (
      this.$route?.name == "Home" ||
      this.$route?.name == "MonthClosing" ||
      this.$route?.name == "ProductAndPackageManagement" ||
      this.$route?.name == "ParametersPage" ||
      this.$route?.name == "RecommendedPackages" ||
      this.$route?.name == "GetManuelReport"
    ) {
      this.isFullWidth = true;
    }
    if (this.$route?.name == "Checkout") {
      this.isCheckout = true;
    }
  },
  methods: {
    updateList() {
      this.breadcrumbList = this.$route?.meta?.breadcrumb;
    },
  },
};
</script>

<style lang="scss">
.breadcrumb {
  padding: 20px 0px;
  @media (max-width: 768px) {
    padding: 12px 0px;
    overflow-x: auto;
  }
  ul {
    display: flex;
  }
  &__item {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    border-radius: var(--radius-first);
    font-size: 13px;
    position: relative;
    &:last-child a {
      font-weight: 700;
      color: var(--grayscale-100);
    }
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      color: var(--grayscale-60);
      text-decoration: none;
      max-width: 290px;
      text-overflow: ellipsis;

      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;

      @media (max-width: 768px) {
        font-size: 12px;
        max-width: inherit;
        min-width: max-content;
        justify-content: flex-start;
      }

      &.router-link-exact-active {
        font-weight: 700;
        color: var(--grayscale-100);
        svg {
          fill: var(--grayscale-100);
        }
      }
    }
    &:first-child {
      padding-left: 0;
    }
    svg {
      margin: 0px 13px;
      fill: var(--grayscale-60);
      @media (max-width: 768px) {
        margin: 0px 3px;
      }
    }
  }
  &__name {
    text-overflow: ellipsis;
    overflow: hidden;
    @media (min-width: 640px) {
      white-space: nowrap;
    }
  }
}
@media (max-width: 768px) {
  .checkoutPage {
    position: relative;
    overflow: auto;
    .breadcrumb {
      min-width: 420px;
      overflow-x: scroll;
    }
  }
}
</style>
